import React,{useState,useEffect} from "react";
import { SERVERURL } from "../../../ServerUrl";
import PartnerEditPage from './PartnerEditPage';

import Swal from "sweetalert2";
import axios from "axios";

const PartnersTable = (props) => {
  const [filtered2, setFiltered2] = useState([]);
  const [selectedRow2, setSelectedRow2] = useState(null);
 
  const updateFilteredData = () => {
    if (props.driverData) { 
      setFiltered2(props.driverData);
    }
  };

  const deleteClicked = async (index, id, row) => {
    console.log(index, id); //mongoid, array index
    console.log(row); //that particular object
  
    Swal.fire({
      title: '',
      text: 'Are you sure to Delete ' + row.fullName + '?',
      icon: 'warning', // Change 'alert' to 'info' for the icon
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then(async (result) => { // Add 'async' before (result)
      if (result.isConfirmed) {
        try {
  
          const token = localStorage.getItem('token'); 
          
          const headers = {
            'Authorization': `Bearer ${token}`, // Corrected header format
          };
          const response = await axios.post(`${SERVERURL}/api/v1/deletePartner`, { id: index },{
            headers: headers, // Include the headers object in the request configuration
          });
          console.log("kuch ni aya" + response.data);
  
          if (response.data.message === "Partner Deleted Successfully!" || response.data.success === true) {
            // Update the state or perform any action on successful verification
            Swal.fire(
              '',
              'Deleted Successfully!',
              'success'
            );

            let zz = filtered2.filter((item) => item.fullName !== row.fullName);
            setFiltered2(zz);
          }
          else
          {
            if(response.data.success === false)
            {
              Swal.fire(
                '',
                response.data.message,
                'error'
              );
            }

          }
        } catch (error) {
          console.log("response 4", error.response)
          if (error.response.data.message) {
            console.error(error.response);
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: 'error', // Change 'Error' to 'error' for the icon
              showCancelButton: true,
              cancelButtonColor: '#d33',
            })
          }
        }
      }
    });
  
  };



  useEffect(() => {
    updateFilteredData();
  }, [props.driverData]); 
  
  
  const handleEditClick = (index) => {
    setSelectedRow2(filtered2[index]);
    
  };
  
  const handleCloseEditDialog = () => {
    setSelectedRow2(null);
  };
  return (
    <div className="admin-table">
      <table className="specialWidthTable" >
        <thead>
          <tr>
            <th>Title</th>
            <th>ProfilePic</th>
             <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filtered2.map((item, index) => (
            <tr key={index}>
            <td className="admin-table-strong">{item.fullName}</td>
            <td className="imagepartner">
            <img className="partnerImageAdminTable" src={SERVERURL+'/uploads/'+item.image}  alt="" /> 
              </td>            
           <td className="admin-actions-cell">
                <button className="admin-action admin-action-edit" onClick={() => handleEditClick(index)}>
                  Edit
                </button>
                <button className="admin-action admin-action-delete" onClick={() => deleteClicked(item._id, index, item)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>



      {selectedRow2 && (
      <PartnerEditPage 
      selectedRow={selectedRow2} 
      onCloseDialog={handleCloseEditDialog}
      
    />
      )}




    </div>
  );
};

export default PartnersTable;